import { render, staticRenderFns } from "./InspectionDetailsHTML.vue?vue&type=template&id=589a03ee&scoped=true&"
import script from "./InspectionDetailsHTML.vue?vue&type=script&lang=js&"
export * from "./InspectionDetailsHTML.vue?vue&type=script&lang=js&"
import style0 from "./InspectionDetailsHTML.vue?vue&type=style&index=0&id=589a03ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589a03ee",
  null
  
)

export default component.exports